import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Card, Col, Row, Table } from "antd";
import { useGetPublishersQuery } from "../api/api";
import Spinner from "../components/Spinner";
import { Error } from "../components/Error.component";






export const PublishersDetails = () => {
  const { PublishersId } = useParams(); // Use the same parameter name as in the route
  const { data, error, isLoading } = useGetPublishersQuery();

  // Filter the data to include only the licenses associated with the given publisher
  const publisherLicenses = useMemo(() => {
    console.log("Data received:", data); // Debugging line
    return data?.data?.filter(item => item.publishername_0 === PublishersId) || [];
  }, [data, PublishersId]);

  // Calculate total number of licenses and total cost
  const totalLicenses = publisherLicenses.length;
  
  const totalCost = publisherLicenses.reduce((sum, item) => sum + (parseFloat(item.totallicensecostperannum_0) || 0), 0);

  const columns = useMemo(() => [
    { 
      title: "License Name", 
      dataIndex: "licensename_0", 
      key: "licensename_0", 
      className: "table-cell-padding",
      sorter: (a, b) => a.licensename_0.localeCompare(b.licensename_0)
    },
    { 
      title: "Unit License cost (Year)", 
      dataIndex: "costperlicenseperannum_0", 
      key: "costperlicenseperannum_0", 
      render: (value) => `$${Math.round(parseFloat(value)).toLocaleString()} `, 
      className: "table-cell-padding",
      sorter: (a, b) => Math.round(parseFloat(a.costpermonth_0)) - Math.round(parseFloat(b.costpermonth_0))
    },
    {
      title: "Total License cost (Year)", 
      dataIndex: "totallicensecostperannum_0", 
      key: "totallicensecostperannum_0", 
      render: (value) => `$${Math.round(parseFloat(value)).toLocaleString()}`, 
      className: "table-cell-padding",
      sorter: (a, b) => Math.round(parseFloat(a.totallicensecostperannum_0)) - Math.round(parseFloat(b.totallicensecostperannum_0))
    },
    { 
      title: "Purchased license amount", 
      dataIndex: "quantitypurchasedlicenses_0", 
      key: "quantitypurchasedlicenses_0", 
      className: "table-cell-padding",
      sorter: (a, b) => parseFloat(a.quantitypurchasedlicenses_0) - parseFloat(b.quantitypurchasedlicenses_0)
    },
   
  ], []);
  

  return (
    <div className="montserrat-font">
      {isLoading && <Spinner />}
      {error && <Error error={"Oops"} />}
      {data && !error && (
        <div>
          <Row gutter={32} style={{ display: 'flex' }}>
            <Col xs={24} sm={12} style={{ display: 'flex' }}>
              <Card title="Publisher Details" className="muse-card" style={{ width: "100%", flex: 1 }}>
                <h3>Publisher Name: <strong>{PublishersId}</strong></h3>
                <h3>Vendor Name:  <strong>{publisherLicenses[0]?.vendorname_0 || 'N/A'}</strong></h3>
                <h3>Contract Number <strong>{publisherLicenses[0]?.contractnumberoracle_0 || 'N/A'}</strong></h3>
              </Card>
            </Col>
            <Col xs={24} sm={12} style={{ display: 'flex' }}>
              <Card title="License Overview" className="muse-card" style={{ width: "100%", flex: 1 }}>
                <h3>Total Publisher Licenses: <strong>{totalLicenses}</strong></h3>
                <h3>Total Publisher Cost: <strong>${Math.round(totalCost).toLocaleString()} (Year)</strong></h3>
                <h3>Cost Department: <strong>{publisherLicenses[0]?.bu || 'N/A'}</strong></h3>
              </Card>
            </Col>
          </Row>

          <Row>
            <Card className="muse-card" style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={publisherLicenses.map((item, index) => ({ ...item, key: index }))}
                className="montserrat-font"
                rowClassName={() => "table-row-spacing"}
                pagination={false}
              />
            </Card>
          </Row>
        </div>
      )}
    </div>
  );
};
